import { compareDivision } from './divisionOrder'
import { formatTime12 } from './clock'
import type { Facet } from './listFilters'
import { weekOptionLabel, weekOptions, type SortableRow, type WeekRow } from './listSort'

/** The facets every game list shares, declared once: two screens that both
 *  filter by field read the same label, order and "Field TBD". Moved here
 *  from the referee app (`refereeFacets.ts`) when the coach, Scheduler and
 *  Stats lists adopted the same control. */
export type GameRow = WeekRow & SortableRow

export const divisionFacet: Facet<SortableRow> = {
  key: 'division', label: 'Division', plural: 'divisions',
  value: (r) => r.division || null, order: compareDivision,
}
/** What a game with no field yet shows, on a row and on the Field facet chip. */
export const FIELD_TBD = 'Field TBD'

export const fieldFacet: Facet<SortableRow> = {
  key: 'field', label: 'Field', plural: 'fields', value: (r) => r.field_name, missingLabel: FIELD_TBD,
}
export const timeFacet: Facet<SortableRow> = {
  key: 'time', label: 'Kickoff time', plural: 'kickoff times',
  value: (r) => r.time || null, optionLabel: formatTime12, missingLabel: 'Time TBD',
}

/** Built from the rows because a week's label carries its earliest date.
 *  `rebuild` relabels it from whatever rows a screen ends up listing. */
export function weekFacet<Row extends WeekRow>(rows: readonly Row[]): Facet<Row> {
  const byWeek = new Map(weekOptions(rows).map((o) => [String(o.week), o]))
  return {
    key: 'week', label: 'Week', plural: 'weeks',
    value: (r) => String(r.week),
    optionLabel: (v) => { const o = byWeek.get(v); return o ? weekOptionLabel(o) : `Week ${v}` },
    order: (a, b) => Number(a) - Number(b),
    rebuild: (scoped) => weekFacet(scoped),
  }
}
